// Storage manager
class Storage {
  constructor() {
    this.storage = window.localStorage;
  }

  getItem(name) {
    return this.storage.getItem(name);
  }

  setItem(name, data) {
    this.storage.setItem(name, data);
  }

  removeItem(name) {
    this.storage.removeItem(name);
  }

  // eslint-disable-next-line class-methods-use-this
  setCookies(name, data, path = '/') {
    if (name === 'joinnus2') {
      const domain = window.location.hostname === 'localhost' ? 'localhost' : 'joinnus.com';
      document.cookie = `${name}=${encodeURIComponent(data)};domain=${domain};path=${path}`;
    } else {
      document.cookie = `${name}=${encodeURIComponent(data)}; path=${path}`;
    }
  }

  // eslint-disable-next-line class-methods-use-this
  deleteCookies(name, path = "/") {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC;path="${path}";`;
  }
}

export default new Storage();
